import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import Icon from './Icon';
import { tel } from '../assets/images';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterSection>
            <FooterTitle>Villa Leïs Auro</FooterTitle>
            <FooterText>
              Une expérience unique au cœur de la nature à Callas. Notre villa de 120 m² sur deux niveaux indépendants avec 4 chambres et piscine privée vous offre un séjour inoubliable dans un cadre exceptionnel.
            </FooterText>

          </FooterSection>
          
          <FooterSection>
            <FooterTitle>Liens Rapides</FooterTitle>
            <FooterLinks>
              <FooterLink to="/">Accueil</FooterLink>
              <FooterLink to="/villa">La Villa</FooterLink>
              <FooterLink to="/gallery">Galerie</FooterLink>
              <FooterLink to="/availability">Disponibilités</FooterLink>
              <FooterLink to="/contact">Contact</FooterLink>
            </FooterLinks>
          </FooterSection>
          
          <FooterSection>
            <FooterTitle>Contact</FooterTitle>
            <ContactInfo>
              <ContactItem>
                <Icon component={FaMapMarkerAlt} />
                <span>Chemin de la Colle, 83830 Callas, France</span>
              </ContactItem>
              <ContactItem>
                <Icon component={FaPhone} />
                <PhoneImageContainer>
                  <img src={tel} alt="Numéro de téléphone" />
                </PhoneImageContainer>
              </ContactItem>
              <ContactItem>
                <Icon component={FaEnvelope} />
                <span><a href="/contact">Contactez-nous</a></span>
              </ContactItem>
            </ContactInfo>
          </FooterSection>
        </FooterContent>
        
        <FooterBottom>
          <Copyright>
            &copy; {currentYear} Villa Leïs Auro. Tous droits réservés.
          </Copyright>
        </FooterBottom>
      </div>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: var(--color-primary);
  color: var(--color-light);
  padding: 6rem 0 2rem;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
  gap: 4rem;
  margin-bottom: 4rem;
`;

const FooterSection = styled.div``;

const FooterTitle = styled.h4`
  color: var(--color-light);
  margin-bottom: 2.5rem;
  font-size: 2.2rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -1rem;
    left: 0;
    width: 5rem;
    height: 2px;
    background-color: var(--color-accent);
  }
`;

const FooterText = styled.p`
  font-size: 1.5rem;
  line-height: 1.8;
  margin-bottom: 2.5rem;
`;

const AirbnbContainer = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  width: 100%;
  
  a {
    color: var(--color-accent);
    text-decoration: underline;
    font-size: 1.4rem;
    display: block;
    margin-bottom: 0.5rem;
    
    &:hover {
      color: var(--color-light);
    }
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

const FooterLink = styled(Link)`
  font-size: 1.5rem;
  color: var(--color-light);
  transition: var(--transition);
  
  &:hover {
    color: var(--color-accent);
    transform: translateX(5px);
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  font-size: 1.5rem;
  
  svg {
    margin-top: 0.3rem;
    font-size: 1.8rem;
    color: var(--color-accent);
  }
`;

const PhoneImageContainer = styled.div`
  img {
    height: 2.5rem;
    vertical-align: middle;
  }
`;

const FooterBottom = styled.div`
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
`;

const Copyright = styled.p`
  font-size: 1.4rem;
  color: rgba(255, 255, 255, 0.7);
`;

export default Footer;
